import { MetaPartnerApiClient } from '@fourthwall/services/dist/MetaPartnerApiClient'
import { createQueryHook } from '@fourthwall/utils'

export const useMetaConfigurationQuery = createQueryHook(
  MetaPartnerApiClient.getMetaConfiguration,
  {
    queryKey: ['metaConfiguration'],
  },
)
